export const LIUNE_ARTDOOR_MODEL_DROPDOWN: {[key: number]: string[]} = {
  //Johanna Oras
  28290: [
    '1. KALLARY',
    '2. Yön sylissä',
    '3. All that she wanted',
    '4. Rakkauden pyörteissä',
    '5. All that he had',
    '6. Passion',
    '7. Magical World of JO',
    '8. Blue Velvet',
    '9. Magical Sampo',
    '10. Onnellisuuden polulla',
    '11. Kallary Gold',
    '12. Time to Fly',
    '2.1. Blue Velvet II',
    '2.2. Maaginen hetki II',
    '2.3. Magical World of JO II',
    '2.4. Yön sylissä II',
    '2.5. Onnellisuuden polulla II',
    '2.6. Kallary Gold II',
    '2.7. Time to Fly II',
  ],
  78032: [
    '1. KALLARY',
    '2. Yön sylissä',
    '3. All that she wanted',
    '4. Rakkauden pyörteissä',
    '5. All that he had',
    '6. Passion',
    '7. Magical World of JO',
    '8. Blue Velvet',
    '9. Magical Sampo',
    '10. Onnellisuuden polulla',
    '11. Kallary Gold',
    '12. Time to Fly',
  ],
  78036: [
    '1. KALLARY',
    '2. Yön sylissä',
    '3. All that she wanted',
    '4. Rakkauden pyörteissä',
    '5. All that he had',
    '6. Passion',
    '7. Magical World of JO',
    '8. Blue Velvet',
    '9. Magical Sampo',
    '10. Onnellisuuden polulla',
    '11. Kallary Gold',
    '12. Time to Fly',
  ],
  78037: [
    '1. KALLARY',
    '2. Yön sylissä',
    '3. All that she wanted',
    '4. Rakkauden pyörteissä',
    '5. All that he had',
    '6. Passion',
    '7. Magical World of JO',
    '8. Blue Velvet',
    '9. Magical Sampo',
    '10. Onnellisuuden polulla',
    '11. Kallary Gold',
    '12. Time to Fly',
  ],
  // Lotta Siren
  55546: [
    "1. I've got my eye on you",
    '2. Strawberry kisses',
    '3. Save your tears for another day',
    '4. Delicate and strong',
    '5. My own heatwave',
    '6. I like you like that',
    '7. Breathing in a fresh forest',
    '8. Burned sugar',
    '9. Swimming in the sunset clouds 1',
    '10. Swimming in the sunset clouds 2',
    '2.1 Tres',
    "2.2 It's not black and white",
    '2.3 Listening to the wind of change',
    '2.4 I like you like that',
  ],
  78038: [
    "1. I've got my eye on you",
    '2. Strawberry kisses',
    '3. Save your tears for another day',
    '4. Delicate and strong',
    '5. My own heatwave',
    '6. I like you like that',
    '7. Breathing in a fresh forest',
    '8. Burned sugar',
    '9. Swimming in the sunset clouds 1',
    '10. Swimming in the sunset clouds 2',
  ],
  78277: [
    "1. I've got my eye on you",
    '2. Strawberry kisses',
    '3. Save your tears for another day',
    '4. Delicate and strong',
    '5. My own heatwave',
    '6. I like you like that',
    '7. Breathing in a fresh forest',
    '8. Burned sugar',
    '9. Swimming in the sunset clouds 1',
    '10. Swimming in the sunset clouds 2',
  ],

  78279: [
    "1. I've got my eye on you",
    '2. Strawberry kisses',
    '3. Save your tears for another day',
    '4. Delicate and strong',
    '5. My own heatwave',
    '6. I like you like that',
    '7. Breathing in a fresh forest',
    '8. Burned sugar',
    '9. Swimming in the sunset clouds 1',
    '10. Swimming in the sunset clouds 2',
  ],
  // Nina Kellokoski
  55547: [
    '1. Rauha II',
    '2. Rauha I',
    '3. Kesä II',
    '4. Kesä I',
    '5. Kellokukka II',
    '6. Kellokukka I',
    '7. Pisara II',
    '8. Pisara I',
    '9. Kukkaketo II',
    '10. Kukkaketo I',
    '11. Helle II',
    '12. Helle I',
    '13. Sade II',
    '14. Sade I',
  ],
  78039: [
    '1. Rauha I',
    '2. Kesä I',
    '3. Kellokukka I',
    '4. Pisara I',
    '5. Kukkaketo I',
    '6. Helle I',
    '7. Sade I',
  ],
  78278: [
    '1. Rauha I',
    '2. Kesä I',
    '3. Kellokukka I',
    '4. Pisara I',
    '5. Kukkaketo I',
    '6. Helle I',
    '7. Sade I',
  ],
  78280: [
    '1. Rauha I',
    '2. Kesä I',
    '3. Kellokukka I',
    '4. Pisara I',
    '5. Kukkaketo I',
    '6. Helle I',
    '7. Sade I',
  ],

  // TAIDE | LD20 Lasi PARIOVET Moomin by Liune
  87120: [
    '1. Family',
    '2. Forest at night',
    '3. Family',
    '4. Forest at night with family',
    '5. The exploits of Moominpappa',
    '6. Swell of the sea',
    '7. Beacon island',
    '8. Beacon of light',
    '9. Storm',
    '10. Hermulens order',
    '11. The hobgoblins world',
    '12. Lighthouse keeper',
  ],
  // TAIDE | LD20 MDF PARIOVET Moomin by Liune
  87121: [
    '1. Family',
    '2. Forest at night',
    '3. Family',
    '4. Forest at night with family',
    '5. The exploits of Moominpappa',
    '6. Swell of the sea',
    '7. Beacon island',
    '8. Beacon of light',
    '9. Storm',
    '10. Hermulens order',
    '11. The hobgoblins world',
    '12. Lighthouse keeper',
  ],
  // TAIDE | LD20 Lasi Moomin by Liune
  87071: [
    '1. Hug',
    '2. Hug with flowers',
    '3. Hug white',
    '4. Hug black',
    '5. Summertime',
    '6. Beach',
    '7. Fishing white',
    '8. Fishing boat',
    '9. Fishing boat sunset',
    '10. Fishing boat yellow',
    '11. Snufkin goes fishing white',
    '12. Snufkin goes fishing',
    '13. Rainy days',
    '14. Moominmamma white',
    '15. Moominmamma blue',
    '16. Moominmamma yellow',
    '17. Fishing white',
    '18. Fishing blue',
    '19. Fishing with boat',
    '20. Fishing multi color',
  ],
  // TAIDE | LD20 MDF Moomin by Liune
  87072: [
    '1. Hug',
    '2. Hug with flowers',
    '3. Hug white',
    '4. Hug black',
    '5. Summertime',
    '6. Beach',
    '7. Fishing white',
    '8. Fishing boat',
    '9. Fishing boat sunset',
    '10. Fishing boat yellow',
    '11. Snufkin goes fishing white',
    '12. Snufkin goes fishing',
    '13. Rainy days',
    '14. Moominmamma white',
    '15. Moominmamma blue',
    '16. Moominmamma yellow',
    '17. Fishing white',
    '18. Fishing blue',
    '19. Fishing with boat',
    '20. Fishing multi color',
  ],
};
